// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { ValidateCreateOrganizationBindingAdmin, ValidateCreateOrganizationBindingAdminSchema } from 'api/gen/ValidateCreateOrganizationBindingAdmin';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { ValidateUpdateOrganizationBindingAdmin, ValidateUpdateOrganizationBindingAdminSchema } from 'api/gen/ValidateUpdateOrganizationBindingAdmin';

export const ValidateOrganizationBindingAdminSchema = t.union([ValidateCreateOrganizationBindingAdminSchema, ValidateUpdateOrganizationBindingAdminSchema]);

export type ValidateOrganizationBindingAdmin = t.TypeOf<typeof ValidateOrganizationBindingAdminSchema>;
